import { z } from "zod";
import { apiRequest } from "./apiUtils";

export const PaymentIntentSchema = z.object({
  createdAt: z.string(),
  updatedAt: z.string(),
  deletedAt: z.string().nullable(),
  id: z.number(),
  status: z.string(),
  last4: z.string(),
  fingerprint: z.string().nullable(),
  user_id: z.string(),
  stripe_customer_id: z.string(),
  stripe_bank_account_id: z.string(),
  stripe_mandate_id: z.string().nullable(),
  setup_intent_id: z.string(),
  failure_reason: z.string().nullable(),
});

export const AchResponseSchema = z.object({
  message: z.string().nullable(),
  success: z.boolean(),
  payment_intent: PaymentIntentSchema.optional(),
  client_secret: z.string().optional(),
});

export type AchResponse = z.infer<typeof AchResponseSchema>;

export async function getAchSetupStatus(): Promise<AchResponse> {

  const res = await apiRequest("payments/ach/status");
  return AchResponseSchema.parse(res);
}

export interface AchSetupRequest {
  accountType: string;
  accountHolderName: string;
  routingNumber: string;
  accountNumber: string;
  accountHolderType: string;
}

export async function setupAchForUser(request: AchSetupRequest): Promise<AchResponse> {
  const res = await apiRequest("payments/ach/setup", {
    method: "POST",
    body: JSON.stringify(request),
  });
  return AchResponseSchema.parse(res);
}

export async function confirmAch(amounts: Array<number>): Promise<AchResponse> {
  const res = await apiRequest("payments/ach/verify", {
    method: "POST",
    body: JSON.stringify({ amounts }),
  });
  return AchResponseSchema.parse(res);
}

export interface StripeConnectSetupRequest {
  businessId: string;
}

export const StripeConnectSetupResponseSchema = z.object({
  success: z.boolean(),
  onboardingUrl: z.string(),
  accountId: z.string(),
});

export type StripeConnectSetupResponse = z.infer<typeof StripeConnectSetupResponseSchema>;

export async function setupStripeConnect(request: StripeConnectSetupRequest): Promise<StripeConnectSetupResponse> {
  const res = await apiRequest(`business/${request.businessId}/stripe-connect/setup`, {
    method: "POST",
  });
  return StripeConnectSetupResponseSchema.parse(res);
}
